module.exports = {
    config: {
        merchantId: 6,
        merchantShopName: "J'aime les gens d'ici",
        merchantDomain: "https://reignier.jaimelesgensdici.shop/",
        defaultMetaImage: "assets/images/meta-shop-picture.png",
        enabledLanguagues: ['fr'],
        defaultLanguage: 'fr',
        enabledCurrencies: ["EUR"],
        defaultCurrency: "EUR",
        enabledDeliveryCountry: ['fr', 'BE', 'NL', 'ES', 'PT', 'DE', 'IT', 'PL', 'AT'],
        nbProductsByPage: 12,
        shopEmail: "shop.reignier@jaimelesgensdici.fr",
        shopPhone: "07 43 57 03 34",
        shopHours: "",
        stripeCountryAccount: 'FR',
        shopAddress: "2484 route de l'Eculaz",
        shopPostalCity: "74930 Reignier-Esery",
        shopCountry: "France",
        shopCountryCode: "FR",
        shopSlogan: {
            "fr": "La vente en ligne rapide et efficace.",
        },
        shopMapsUrl: "https://goo.gl/maps/3or1JY9cHFu3utBB8",
        socialMedias: {
            facebook: "https://www.facebook.com/jaimelesgensdici",
            instagram: "https://www.instagram.com/jaimelesgensdici/"
        },
        footerLink: [
            {
                "name": "FOOTER_LNOTICE",
                "url": "/legal-notice"
            },
            {
                "name": "FOOTER_TERMS",
                "url": "/terms-of-sales"
            },
            {
                "name": "FOOTER_PRIVACY",
                "url": "/privacy-policy"
            },
        ],
        menu: [
            {
                "name": "NAV_HOME",
                "path": "home",
                "submenu": []
            },
            {
                "name": "NAV_CATALOG",
                "path": "catalog",
                "submenu": []
            },
            {
                "name": "Contact",
                "path": "contact",
                "submenu": []
            }
        ],
        mondialRelayCode: "CC23PRY8",
        mondialRelayColLivMod: "24R",
        stripeKey: "pk_live_51IDX9sFONvuSNpV2o5KatJP8qQncNXdbw5DfzLuVwEoRk6dyyxdC0U3WasFIWMO25RidY1DF6TO9HncLY1YMyDrl00vpUhDuJU",
        stripeAccount: "acct_1SNt2lF7SF13fgtl",
        quoteDownloadEnabled: false,
        reviewEnabled: false,
        defaultCatalogSorting: 'RELEVANCE',
        outOfStockMessage: "Bientôt de retour",
        enabledB2B: false,
        continueShoppingBehavior: 'stay',
        redirect: []
    }
}
